import Phaser from 'phaser';
import ScreenContainer from '../display/ui/ScreenContainer';
import Scene from '../games/food/Scene';
import ControllerTouch from '../games/food/ControllerTouch';
import GameHud from '../games/food/ui/GameHud';

export default class MiniGameFood extends Phaser.State {
  init({ locationid }) {
    this.locationid = locationid;
  }

  create() {
    this.container = new ScreenContainer(this.game);

    this.state = MiniGameFood.STATE_INTRO;
    this.time = MiniGameFood.TIME_GAME; // game time
    this.score = 0;

    // scene
    this.scene = new Scene(this.game);
    this.container.addChild(this.scene);
    this.scene.onGetPoint.add(this.handleGetPoint, this);
    this.scene.onMealOnPosition.add(this.handleMealOnPosition, this);

    // game hud
    this.gameHud = new GameHud(this.game);
    this.game.add.existing(this.gameHud);

    if (!this.game.gameController.player.getTutorialSeen('foodgame')) {
      this.game.gameController.player.setTutorialSeen('foodgame');
      this.gameHud.showInstructions();
      this.gameHud.overlayInstructions.onClose.add(this.handleInstructionsClose, this);
    } else {
      this.handleInstructionsClose();
    }

    //
    this.controller = new ControllerTouch(this.game, this);
    this.controller.start();
    this.controllsOn = false;

    //
    this.game.sounds.playSpriteSFX('music', {
      spriteID: 'game_audiosprite',
      loop: true,
      volume: 0.3,
    });
  }

  handleInstructionsClose() {
    if (this.gameHud.overlayInstructions) {
      this.gameHud.overlayInstructions.onClose.remove(this.handleInstructionsClose, this);
    }
    this.state = MiniGameFood.STATE_PLAY;
    this.scene.start();
  }

  handleGetPoint() {
    this.score++;
    this.gameHud.setScore(this.score);
  }

  handleMealOnPosition() {
    // start counting time on action
    this.timeForEat = MiniGameFood.TIME_FOR_EAT;
    // enable input controller
    this.controllsOn = true;
  }

  handleContinueGame() {
    this.game.gameController.endMiniGame();
  }

  swipeUp() {
    if (this.controllsOn) {
      this.scene.feed();
      this.controllsOn = false;
    }
  }

  swipeDown() {
    if (this.controllsOn) {
      this.scene.throwAway();
      this.controllsOn = false;
    }
  }

  update() {
    if (this.state == MiniGameFood.STATE_PLAY) {
      let dt = Math.min(0.05, this.game.time.elapsedMS / 1000);
      this.time -= dt;
      this.time = Math.max(0, this.time);
      this.gameHud.setTime(this.time / MiniGameFood.TIME_GAME);

      // play clock sound
      if (this.time < 5) {
        if (!this.sndClock) {
          this.sndClock = this.game.sounds.playSpriteSFX('clock', {
            spriteID: 'game_audiosprite',
            ignoreIfPlaying: true,
            volume: 1,
          });
        } else {
          let volume = 2 + 4 * (1 - this.time / 5);
          this.sndClock.volume = volume;
        }
      }

      if (this.time <= 0) {
        // game over
        this.state = MiniGameFood.STATE_END;
        this.scene.stop();
        this.controller.stop();
        this.controllsOn = false;
        this.gameHud.showSummary(this.score);

        this.game.sounds.stopSFX('clock', {
          spriteID: 'game_audiosprite',
        });

        this.game.sounds.playSpriteSFX('Sh_WellScoobWeDidItAgain', {
          spriteID: 'foodgame_vo',
          volume: 1,
        });
      }

      // time for user action
      if (this.timeForEat > 0 && this.controllsOn) {
        this.timeForEat -= dt;
        if (this.timeForEat <= 0) {
          // time for user action is out -> lean back and serve new meals
          this.controllsOn = false;
          this.scene.leanBack();
        }
      }
    }
  }

  shutdown() {
    this.game.sounds.stopSFX('music', { spriteID: 'game_audiosprite' });

    this.scene.destroy();
    this.gameHud.destroy();
    this.container.destroy();
    this.controller.stop();

    this.sndClock = null;
    this.scene = null;
    this.gameHud = null;
    this.container = null;
    this.controller = null;
  }
}

MiniGameFood.STATE_INTRO = 1;
MiniGameFood.STATE_PLAY = 2;
MiniGameFood.STATE_END = 3;

MiniGameFood.TIME_GAME = 30; //4 to test game over
MiniGameFood.TIME_FOR_EAT = 2;



// WEBPACK FOOTER //
// ./js/app/states/MiniGameFood.js